/**
 * Product analytics for the marketing site.
 *
 * Events are POSTed to the app-bff public pulse ingest (the sanctioned
 * server-side analytics path), which forwards them to Loki/Grafana. Every event
 * is tagged `app=novaquantis-www` so it's filterable apart from the main web-app.
 * Fire-and-forget; never throws — analytics must not break the UI.
 */

const ANALYTICS_URL =
  import.meta.env.VITE_ANALYTICS_URL ??
  'https://app.novaquantis.ai/api/pulse/public/ingest';

const APP = 'novaquantis-www';
const SESSION_KEY = 'nq_www_session_id';

/** Stable per-visitor id (server hashes it into visitor_id for session panels). */
function sessionId(): string {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return 'anonymous';
  }
}

export function trackEvent(name: string, attributes: Record<string, string> = {}): void {
  try {
    const body = JSON.stringify({
      name,
      domain: 'novaquantis.user_action',
      attributes: {
        app: APP,
        source: APP,
        session_id: sessionId(),
        page: location.pathname,
        url: location.href,
        ...attributes,
      },
    });

    // The bff requires a correlation id; sendBeacon can't set headers, so use
    // keepalive fetch (survives unload) with the NQ correlation header.
    void fetch(ANALYTICS_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Nq-Correlation-Id': crypto.randomUUID(),
      },
      body,
      keepalive: true,
    });
  } catch (error) {
    console.error('trackEvent failed:', error);
  }
}

/** Emit a single page-view event on load. */
export function trackPageView(): void {
  trackEvent('page_view');
}
